<template>
  <el-dialog
    :title="title"
    append-to-body
    destroy-on-close
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="520px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="30px">
      <el-form-item prop="date">
        <el-date-picker
          v-model="form.date"
          type="month"
          style="width: 400px;"
          value-format="yyyy-MM"
          placeholder="请选择时间"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSubmit" :disbaled="loadingSubmit" @click="submitForm">下 载</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  export default {
    data () {
      return {
        title: '下载',
        api: undefined,
        visible: false,
        loadingSubmit: false,
        // 表单参数
        form: {
          date: undefined,
        },
        // 表单校验
        rules: {
          date: [
            {required: true, message: '请选择时间', trigger: 'blur'}
          ],
        },
        fileName: undefined,
        apiQueryStr: undefined
      }
    },
    watch: {
      visible (val) {
        if (!val) {
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
    },
    methods: {
      show(data) {
        const { api, apiQueryStr, title } = data
        this.title = title + this.title
        this.apiQueryStr = apiQueryStr
        this.fileName = title
        this.api = api
        this.visible = true
      },
      async submitForm() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let url = this.api + `?dateTime=${this.form.date + '-01'}&pageIndex=1&pageSize=999999`
            if (this.apiQueryStr) {
              url = url + this.apiQueryStr
            }
            axios({
              method: 'GET',
              url: url,
              responseType:'blob'
            }).then(res => {
              if (res.data && res.data.size > 0) {
                const blob = new Blob([res.data], { type: 'application/x-zip-compressed' })
                const fileName = `${moment(this.form.date).format('YYYY年MM月')}-${this.fileName}`
                if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                  window.navigator.msSaveOrOpenBlob(blob, fileName)
                } else {
                  const elink = document.createElement('a')
                  elink.download = fileName
                  elink.href = URL.createObjectURL(blob)
                  document.body.appendChild(elink)
                  elink.click()
                  URL.revokeObjectURL(elink.href) // 释放URL 对象
                  document.body.removeChild(elink)
                }
              } else {
                this.$message.error('暂无数据可以导出')
              }
            }).catch(function(err) {
              console.log(err)
            })
          }
        });
      },
      /*取消*/
      cancel () {
        Object.assign(this.$data, this.$options.data.call(this));
      },
    }
  }
</script>

<style scoped lang="scss">

</style>
